import logger from '../log';
import deduplicateCandidates from './deduplicateCandidates';
import findIceCandidates from './util/findIceCandidates';
import storeNetworkData, { parseIceCandidates } from './storeNetworkData';
import { GatherArgs, IceCandidateStructure } from './interfaces';

const log = logger.getLogger(__filename);

/**
 * Get the ip data for this node.
 * @example
 * ```ts
 * gatherIceCandidates(\{ iceServers: [\{ urls: 'stun:stun.l.google.com:19302' \}] \}).then(candidates => foo(candidates));
 * ```
 * @param rtcConfiguration - RTCConfiguration for the RTCPeerConnection Ex. \{ iceServers: [\{ urls: 'stun:stun.l.google.com:19302' \}] \}
 * @param dataChannelOptions - RTCDataChannelInit config for RTCDataChannel
 * @param timeout - (Default: 4000) timeout for gathering in milliseconds. If the passed timeout is less than 1000 milliseconds then the default will be used.
 */
export default async function gatherIceCandidates(
  opts?: GatherArgs
): Promise<IceCandidateStructure> {
  const candidates = deduplicateCandidates(await findIceCandidates(opts));
  try {
    const networkData = parseIceCandidates(candidates);
    storeNetworkData(networkData);
    return { candidates, networkData };
  } catch (e) {
    log.warn('Failed to gather networkData from iceCandidates', e);
    return { candidates };
  }
}
